import { createSelector } from 'reselect';
import { containsTextCaseInsensitive } from 'lib/utils/strings';
import { getSelectWorkOrderOpOptions } from './getSelectWorkOrderOp';
import { getMachines } from './getMachines';

/**
 * Selector that returns machine references that match the current search criteria.
 * Used for filtering work order operations by machine name or ERP machine ID.
 *
 * @returns {string[]} Array of machine references that match the search term
 */
export const getSelectWorkOrderOpSearchMachineRefs = createSelector(
  getSelectWorkOrderOpOptions,
  getMachines,
  (options, machines) => {
    const { isSearchMode, search } = options || {};

    // Early return if not in search mode or no search term provided
    if (!isSearchMode || !search?.trim()?.length) {
      return [];
    }

    // Ensure machines is an array to prevent runtime errors
    const machineList = Array.isArray(machines) ? machines : [];

    // Filter machines that match the search term in name or ERP ID
    const matchingMachineRefs = machineList
      .filter((machine) => {
        // Skip machines without required properties
        if (!machine) return false;

        const { name, erpMachineId } = machine;

        // Check if search term matches machine name or ERP machine ID
        return (
          containsTextCaseInsensitive(name, search) ||
          containsTextCaseInsensitive(erpMachineId, search)
        );
      })
      .map((machine) => {
        return machine.machineRef;
      })
      .filter(Boolean); // Remove any null/undefined machine references

    return matchingMachineRefs;
  }
);
